
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";
import { ParteProps } from "./ParteInterface";

// Definición de defaults

export const defaultExhortoRecibido: ExhortoRecibidoProps = { 
    idExhortoRecibido: 0, 
    numeroExhorto: '', 
    numeroFolio: '', 
    numeroExpedienteOrigen: '', 
    cuantia: '',
    idJuez: 0,
    juez: '',
    idSecretario: 0,
    secretario: '',
    idTipoJuicio: 0, 
    tipoJuicio: '', 
    idAutoridadExhortoRecibido: 0, 
    autoridadExhortoRecibido: '', 
    idEstatus: 0,
    estatus: '',
    digitalizacion: '',
    idEtapa: 0,
    etapa: '',
    idSubEtapa: 0,
    subEtapa: '',
    idJuzgadoOrigen: 0,
    juzgadoOrigen: '',
    idClaseExhorto: 0,
    claseExhorto: '',
    idObjetoExhorto: 0,
    objetoExhorto: '',
    folioBuzonElectronico: '',
    escritoBuzonElectronico: '',
    acuseBuzonElectronico: '',
    partes: [],
    actores: [], 
    demandados: [], 
    anexosBuzonElectronico: [],
    caratula: '',
};

export const defaultExhortoRecibidoResponse: BuscarExhortoRecibidoResponse = {
    ...defaultHttpResponse,
    ...defaultExhortoRecibido,
};

export const defaultExhortoRecibidoAnterior: ExhortoRecibidoAnteriorProps = { 
    idExhortoRecibido: 0, 
    numeroExhorto: '', 
    numeroFolio: '', 
    numeroExpedienteOrigen: '', 
    idAutoridad: 0, 
    idTipoJuicio: 0, 
    tipoJuicio: '', 
    idAutoridadExhortoRecibido: 0, 
    autoridadExhortoRecibido: '', 
    idClaseExhorto: 0, 
    claseExhorto: '', 
    idObjetoExhorto: 0, 
    objetoExhorto: '', 
    juez: '', 
    juzgado: '', 
    presentante: '', 
    sintesis: '', 
    partes: [], 
    idEtapa: 0, 
    etapa: '', 
    idSubEtapa: 0, 
    subEtapa: '', 
    encontrado: false, 
};

export const defaultExhortoRecibidoAnteriorResponse: ExhortoRecibidoAnteriorResponse = {
    ...defaultHttpResponse,
    ...defaultExhortoRecibidoAnterior,
};

export const defaultGenerarCaratulaExhorto: GenerarCaratulaExhortoResponse = {
    ...defaultHttpResponse,
    caratula: '',
};

// Creación de interfaces

export interface ExhortoRecibidoProps {
    idExhortoRecibido:              number;
    numeroFolio:                    string;
    numeroExhorto:                  string;
    numeroExpedienteOrigen:         string;
    cuantia:                        string;
    idTipoJuicio:                   number;
    tipoJuicio:                     string;
    idAutoridadExhortoRecibido:     number;
    autoridadExhortoRecibido:       string;
    folioBuzonElectronico:          string;
    escritoBuzonElectronico:        string;
    acuseBuzonElectronico:          string;
    idEstatus:                      number;
    estatus:                        string;

    idJuez:                         number;
    juez:                           string;
    idSecretario:                   number;
    secretario:                     string;
    digitalizacion:                 string;
    idEtapa:                        number;
    etapa:                          string;
    idSubEtapa:                     number;
    subEtapa:                       string;
    idJuzgadoOrigen:                number;
    juzgadoOrigen:                  string;
    fecha?:                         Date;

    idObjetoExhorto:                number;
    objetoExhorto:                  string;
    idClaseExhorto:                 number;
    claseExhorto:                   string;

    actores:                        string[];
    demandados:                     string[];
    partes:                         ParteProps[];
    caratula:                       string;
    anexosBuzonElectronico:         AnexosBuzonElectronicoProps[];
}

export interface BuscarExhortoRecibidoParams {
    numeroExhortoRecibido:      string;
    idAutoridad:                number;
}

export interface ExhortoRecibidoAnteriorProps {
    idExhortoRecibido:              number;
    idTipoJuicio:                   number;
    tipoJuicio:                     string;
    idEtapa:                        number;
    etapa:                          string;
    idSubEtapa:                     number;
    subEtapa:                       string;
    idAutoridad:                    number;
    numeroExhorto:                  string;
    numeroFolio:                    string;
    numeroExpedienteOrigen:         string;
    idAutoridadExhortoRecibido:     number;
    autoridadExhortoRecibido:       string;
    idClaseExhorto:                 number;
    claseExhorto:                   string;
    idObjetoExhorto:                number;
    objetoExhorto:                  string;
    juez:                           string;
    juzgado:                        string;
    presentante:                    string;
    sintesis:                       string;
    encontrado:                     boolean;
    partes:                         ExhortoRecibidoAnteriorParteProps[];
    fechaRadicacion?:               Date;
    fechaPresentacion?:             Date;
}

export interface ExhortoRecibidoAnteriorParteProps {
    nombre:             string;
    apellidoPaterno:    string;
    apellidoMaterno:    string;
    sexo:               number;
    personaMoral:       number;
    tipo:               string;
}

export interface BuscarExhortoRecibidoResponse extends HttpResponse, ExhortoRecibidoProps { }

export interface BuscarExhortoRecibidoAnteriorParams {
    numeroExhorto:      string;
    idAutoridad:        number;
}

export interface ExhortoRecibidoAnteriorResponse extends HttpResponse, ExhortoRecibidoAnteriorProps { }

export interface GuardarExhortoRecibidoAnteriorParams {
    idTipoJuicio:                   number;
    idEtapa:                        number;
    idSubEtapa:                     number;   
    idAutoridad:                    number;
    idAutoridadExhortoRecibido:     number;
    idClaseExhorto:                 number;
    idObjetoExhorto:                number;
    numeroExhorto:                  string;
    numeroFolio:                    string;
    numeroExpedienteOrigen:         string; 
    fechaDevolucion:                string; 
    fechaRadicacion?:               Date;
    fechaPresentacion?:             Date;
    partes:                         ExhortoRecibidoAnteriorParteProps[];
}

export interface AnexosBuzonElectronicoProps {
    archivo:        string;          
    descripcion:    string;                  
    url:            string;              
}

export interface EditarExhortoRecibidoParams {
    idExhortoRecibido:  number;
    idTipoJuicio:       number;
    cuantia:            string;
}

export interface AgregarPartesExhortoRecibidoParams {
    idExhortoRecibido:  number;
    partes:             ParteProps[];
}

export interface GenerarCaratulaExhortoResponse {
    success:        boolean;
    message:        string;
    caratula:       string;
}